// import $ from 'jquery';

$("#search-sort-selecter").on("change", function () {
  $("#search-sort").val($(this).val());
  $("#search-form").submit();
});

$("#search-maker").on("change", function () {
  $("#search-model").prop("selectedIndex", 0);
  $("#search-type").prop("selectedIndex", 0);
  updateSearchResultCount();
});

$(".search-obj").on("change", function () {
  updateSearchResultCount();
});

function updateSearchResultCount() {
  $("#pre-result__count").addClass("re_count");

  var data = {};
  data["action"] = "getPreResult";
  data["maker"] = $("[name=\"maker\"]").val();
  data["model"] = $("[name=\"model\"]").val();
  data["type"] = $("[name=\"type\"]").val();
  data["minPrice"] = $("[name=\"minPrice\"]").val();
  data["maxPrice"] = $("[name=\"maxPrice\"]").val();
  data["minYear"] = $("[name=\"minYear\"]").val();
  data["maxYear"] = $("[name=\"maxYear\"]").val();
  data["minDist"] = $("[name=\"minDist\"]").val();
  data["maxDist"] = $("[name=\"maxDist\"]").val();

  $(".form-item__color").each(function () {
    if ($(this).prop("checked")) {
      var obj_name = $(this).attr("name");
      data[obj_name] = "1";
    }
  });

  $.ajax({
    url: "index.php",
    type: "post",
    dataType: "json",
    data: data
  })
    .done(function (data) {
      $("#pre-result__count").html(data.cnt + "件");
      if (data.cnt > 0) {
        $("#pre-result__count__none").hide();
        $("#pre-result__count__exist").show();
      } else {
        console.log(data.cnt);
        $("#pre-result__count__exist").hide();
        $("#pre-result__count__none").show();
      }
      $("#pre-result__count").removeClass("re_count");
      $("#search-model").html(data.selecter.model);
      $("#search-type").html(data.selecter.type);
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      console.log("jqXHR:");
      console.log(jqXHR);
      console.log("textStatus:" + textStatus);
      console.log("errorThrown:" + errorThrown);
    });
}

$(".c-btn--reset").on("click", function () {
  $("#search-form select").each(function () {
    $(this).prop("selectedIndex", 0);
  });

  $(".form-item__color").each(function () {
    $(this).prop("checked", false);
  });

  updateSearchResultCount();
});

$(".c-btn--submit").on("click", function () {
  $(this).attr("action", "index.php");
  $("#search-form").submit();
});

//ラジオボタンの状態を取得・店舗名の表示切り替え
$('input[name="ownership"]:radio').change(function () {
  var radioval = $(this).val();
  if (radioval == 'カートルズ共有在庫') {
    var yardsHeight = $('.yards').innerHeight();
    var w = $(window).width();
    if (w > 600) {
      $('.form-item__stock').css('padding-bottom', yardsHeight);
    } else {
      $('.form-item__stock').css('padding-bottom', '0');
    }
    $('.yards').show();
  } else {
    $('.form-item__stock').css('padding-bottom', '0');
    $('.yards').hide();
  }
});

//リサイズ時の対応
var checkResize;
$(window).on('load resize', function () {
  clearTimeout(checkResize);
  checkResize = setTimeout(resizing, 100);
});
// リサイズ完了時に実行する処理
function resizing() {

  if ($('input[name=ownership]:checked').val() === 'カートルズ共有在庫') {
    var yardsHeight = $('.yards').innerHeight();
    var w = $(window).width();
    if (w > 600) {
      $('.form-item__stock').css('padding-bottom', yardsHeight);
    } else {
      $('.form-item__stock').css('padding-bottom', '0');
    }
    // $('.yards').show();
  } else {
    $('.form-item__stock').css('padding-bottom', '0');
    // $('.yards').hide();
  }
}

//フォームの表示切り替え
$('.search-module__title').on('click', function () {
  $(this).toggleClass('js-on');
  $(this).next('#search-form').slideToggle();
});

//yardのチェックボックス制御
$(function () {
  if ($('.yard__input:checked')[0]) { } else {
    $('#all').prop('checked', true);
  }
  $('#all').on('click', function () {
    if ($(this).prop("checked")) {
      $('.yard__input').prop('checked', false);
    } else {
      $('.yard__input').prop('checked', false);
    }
  });
  $(".yard__input").on('click', function () {
    if ($('.yard__input:checked').length == $('.yard__input').length) {
      $('#all').prop('checked', true);
      $('.yard__input').prop('checked', false);
    } else if ($('.yard__input:checked').length == 0) {
      $('#all').prop('checked', true);
    } else {
      $('#all').prop('checked', false);
    }
  });
});
